var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{ref:"loginView",staticClass:"pa-0",attrs:{"fluid":"","fill-height":"","id":"container"}},[_c('div',{staticClass:"mobile-splash-box"},[_c('div',{staticClass:"mobile-splash-img1"}),_c('div',{staticClass:"mobile-splash-img2"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }